import { useMutation, useQueryClient } from '@tanstack/react-query';
import { budgetService } from '@services/budget';
import { toast } from 'react-toastify';
import { PENDING_BUDGET_REQUESTS_QUERY_KEY } from './usePendingBudgetRequests';
import { BUDGET_REQUEST_DETAILS_QUERY_KEY } from './useBudgetRequestDetails';
import { BUDGET_REQUESTS_BY_TASK_ID_QUERY_KEY } from './useBudgetRequestsByTaskId';
import { PAGINATED_BUDGET_REQUESTS_QUERY_KEY } from './usePaginatedBudgetRequests';
import { useTranslation } from '@hooks/useTranslation';

export const useAcceptBudgetRequest = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (budgetRequestId: string) => budgetService.acceptBudgetRequest(budgetRequestId),
    onSuccess: () => {
      toast.success(tActionMessages.budgetRequestAcceptedSuccessfully);
      queryClient.invalidateQueries({ queryKey: [PAGINATED_BUDGET_REQUESTS_QUERY_KEY], refetchType: 'active' });
      queryClient.invalidateQueries({ queryKey: [PENDING_BUDGET_REQUESTS_QUERY_KEY], refetchType: 'active' });
      queryClient.invalidateQueries({ queryKey: [BUDGET_REQUEST_DETAILS_QUERY_KEY], refetchType: 'active' });
      queryClient.invalidateQueries({ queryKey: [BUDGET_REQUESTS_BY_TASK_ID_QUERY_KEY], refetchType: 'active' });
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.errors?.[0]?.message || error?.message || tActionMessages.requestError,
      );
    },
  });
};